import React from 'react';
import '../styles/wave-animation.css';

const WaveAnimation = ({
  size = 'medium',
  animated = true,
  onPlayClick = null,
  isPlaying = false,
  isLoading = false
}) => {
  // Wave data matching hero section exactly (17 waves) - more compact (50% reduction)
  const waveData = [
    { height: 16, delay: 0 },
    { height: 28, delay: 0.08 },
    { height: 44, delay: 0.16 },
    { height: 60, delay: 0.24 },
    { height: 72, delay: 0.32 },
    { height: 60, delay: 0.4 },
    { height: 44, delay: 0.48 },
    { height: 28, delay: 0.56 },
    { height: 16, delay: 0.64 },
    { height: 24, delay: 0.72 },
    { height: 40, delay: 0.8 },
    { height: 56, delay: 0.88 },
    { height: 64, delay: 0.96 },
    { height: 56, delay: 1.04 },
    { height: 40, delay: 1.12 },
    { height: 24, delay: 1.2 },
    { height: 16, delay: 1.28 }
  ];

  // Size configurations (scales down the hero section size)
  const sizeConfigs = {
    small: {
      containerWidth: '80px',
      containerHeight: '35px',
      waveWidth: '3px',
      gap: '2px',
      scale: 0.3,
      playButtonSize: '20px',
      playButtonFontSize: '9px',
      playButtonTop: '-6px'
    },
    medium: {
      containerWidth: '120px',
      containerHeight: '50px',
      waveWidth: '4px',
      gap: '2px',
      scale: 0.5,
      playButtonSize: '30px',
      playButtonFontSize: '12px',
      playButtonTop: '-8px'
    },
    large: {
      containerWidth: '220px',
      containerHeight: '100px',
      waveWidth: '8px',
      gap: '4px',
      scale: 1,
      playButtonSize: '80px',
      playButtonFontSize: '32px',
      playButtonTop: '15px'
    }
  };

  const config = sizeConfigs[size] || sizeConfigs.medium;
  const maxHeight = 72; // Maximum height from wave data (reduced for more compact appearance)

  return (
    <div
      className={`wave-animation-container ${animated ? 'animated' : ''}`}
    >
      <div
        className={`wave-animation ${animated ? 'animated' : ''}`}
        style={{
          width: config.containerWidth,
          height: config.containerHeight,
          gap: config.gap
        }}
      >
        {waveData.map((wave, index) => (
          <div
            key={index}
            className="wave-bar"
            style={{
              width: config.waveWidth,
              height: `${(wave.height / maxHeight) * 100}%`,
              animationDelay: `${wave.delay}s`
            }}
          />
        ))}
        <button
          className="wave-play-button"
          onClick={onPlayClick}
          disabled={isLoading || !onPlayClick}
          aria-label={isPlaying ? 'Pause demo audio' : 'Play demo audio'}
          style={{
            width: config.playButtonSize,
            height: config.playButtonSize,
            fontSize: config.playButtonFontSize,
            top: config.playButtonTop,
            cursor: onPlayClick ? 'pointer' : 'default'
          }}
        >
          {isLoading ? (
            <span className="loading-spinner-wave"></span>
          ) : isPlaying ? (
            <span>⏸</span>
          ) : (
            <span>▶</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default WaveAnimation;
